import * as React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Error from "../Error/Error";
import { bordo, white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down }, spacing }) => ({
  calendarStyles: {
    marginBottom: "10px",
    width: "100%",

    "&.MuiOutlinedInput-root.Mui-error": {
      borderColor: "none",
    },

    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, 15px) scale(0.75)",
    },

    "& label": {
      paddingLeft: "15px",
      top: "-2px",
      zIndex: 1,
    },

    "& label.Mui-focused, & label.MuiFormLabel-filled": {
      paddingLeft: 0,
      // top: "2px",
      top: "-8px",
      left: "2px",
      fontSize: "12px",
    },

    "& .MuiInput-input": {
      padding: "20px 15px",
    },

    "& .MuiInputBase-root:hover": {
      borderColor: "#111E26",
    },

    "& .Mui-focused.MuiInputBase-root": {
      border: `2px solid ${bordo}`,
    },

    "& .MuiFormHelperText-filled": {
      display: "none",
    },

    "& .MuiFormLabel-root.Mui-error": {
      color: "#666666",
    },

    "& .MuiInputBase-root": {
      height: "62px",
      border: "1px solid #D7D7D7",
      borderRadius: "10px",
      fontFamily: "sbcBold",
      color: "#282F36",
      fontSize: "16px",
      lineHeight: 1.2,
      marginTop: 0,
      background: white,

      "&::after": {
        content: "none",
      },

      "&::before": {
        content: "none",
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D7D7D7",
      },
    },
  },
}));

const CustomDatePicker = ({ ...props }) => {
  const classes = useStyles();
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";
  return (
    <FormControl error={!!errorText} className={classes.calendarStyles}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Controller
          {...props}
          control={control}
          render={({ ref, ...rest }) => (
            <KeyboardDatePicker
              variant="inline"
              label={props.label}
              views={["month", "year"]}
              format="MM/yy"
              openTo="month"
              disablePast
              minDate={new Date()}
              {...props}
              {...rest}
            />
          )}
        />
      </MuiPickersUtilsProvider>
      <FormHelperText>
        {errorText && <Error errorMessage={"Must be a valid date"} />}
      </FormHelperText>
    </FormControl>
  );
};

export default CustomDatePicker;
